import { Image, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from "@chakra-ui/react";

interface ImageModalProps {
    isOpen: boolean;
    onClose: () => void;
    imageUrl: string;
}

export default function ImageModal(props: ImageModalProps) {
    return (
        <Modal motionPreset="slideInBottom" isOpen={props.isOpen} onClose={props.onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalBody padding={0}>
                    <Image src={props.imageUrl} alt="image" width={"100%"} height={"100%"} objectFit={"cover"} />
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}